import { useCallback } from "react";

import { transcribeAudio } from "../../mutations/TranscribeAudioMutation";
import {
  STT_ERROR_CODE_INVALID_AUDIO,
  STT_ERROR_CODE_NETWORK
} from "./SpeechToTextRecorderError";

// GraphQL mutation inputs are text-only; convert blobs to base64 payloads before request
// for transcription.
const useSpeechTranscriptionRequest = resourceId => {
  const blobToBase64 = useCallback(audioBlob => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();

      fileReader.onloadend = () => {
        const dataUri = fileReader.result?.toString() || "";
        const [, base64Content] = dataUri.split(",");

        if (!base64Content) {
          reject(new Error(STT_ERROR_CODE_INVALID_AUDIO));
          return;
        }

        resolve(base64Content);
      };

      fileReader.onerror = () => reject(new Error(STT_ERROR_CODE_INVALID_AUDIO));
      fileReader.readAsDataURL(audioBlob);
    });
  }, []);

  return useCallback(
    async (audioBlob, audioContentType) => {
      let audioBase64;

      try {
        audioBase64 = await blobToBase64(audioBlob);
      } catch {
        throw new Error(STT_ERROR_CODE_INVALID_AUDIO);
      }

      return new Promise((resolve, reject) => {
        transcribeAudio(
          {
            resourceId,
            audioBase64,
            audioContentType
          },
          response => resolve(response?.transcribeAudio),
          () => reject(new Error(STT_ERROR_CODE_NETWORK))
        );
      });
    },
    [blobToBase64, resourceId]
  );
};

export default useSpeechTranscriptionRequest;
